export const LEAVE_TYPES = [
    'Annual Leave',
    'Business Trip',
    'Emergency Leave',
    'Important Leave',
    'Maternity & Paternity Leave',
    'PHL (Pengganti Hari Libur)',
    'Sick Leave',
    'WFH (Work From Home)',
];

export const LEAVE_STATUSES = [
    'Pending',
    'Approved',
    'Rejected',
];

export const HR_OVERVIEW_ROLES = [
    'it',
    'super',
    'management',
];
